// Reine Formatierungs-/Hilfsfunktionen - kein Vue-Bezug, isoliert testbar.

export function formatTagAnzeige(schluessel) {
  const z = formatTagZweiteilig(schluessel)
  const heute = new Date(); heute.setHours(0, 0, 0, 0)
  const ziel = new Date(schluessel); ziel.setHours(0, 0, 0, 0)
  const diff = Math.round((ziel - heute) / 86400000)

  const kurz = diff === 0 ? 'Heute' : diff === 1 ? 'Morgen' : diff === -1 ? 'Gestern' : null
  const label = kurz ? { ...z, wochentag: kurz, wochentagShort: kurz } : z
  return { ...label, text: `${label.wochentagShort} ${label.datum}` }
}

// YYYY-MM-DD, für den 'from'/'to'-Request-Parameter
export function isoDatum(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

// YYYY-MM-DD in lokaler Zeit, unabhängig von Locale/Timezone-Formatierung
export function tagSchluessel(zeit) {
  const d = new Date(zeit)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function formatTag(schluessel) {
  // Kann während der kurzen Übergangsphase null sein (aktuellerTagIndex startet bei -1, bis
  // springeZuHeute() den echten Tag setzt - siehe useSpielplanData.js) - ohne diese Absicherung
  // würde der Aufruf mit "Cannot read properties of null" abstürzen, statt einfach kurz leer zu
  // bleiben.
  if (!schluessel) return ''
  const [jahr, monat, tag] = schluessel.split('-').map(Number)
  const datum = new Date(jahr, monat - 1, tag)
  const wochentag = datum.toLocaleDateString('de-DE', { weekday: 'short' }).replace('.', '').toUpperCase()
  // Kurzform: Tag + kurzer Monatsname, KEIN Jahr - z.B. "DI, 01. Sept" statt "DI, 01.09.2026"
  const rest = datum.toLocaleDateString('de-DE', { day: '2-digit', month: 'short' })
  return `${wochentag}, ${rest}`
}

export function formatTagZweiteilig(schluessel) {
  if (!schluessel) return { wochentag: '', datum: '' }
  const [jahr, monat, tag] = schluessel.split('-').map(Number)
  const d = new Date(jahr, monat - 1, tag)
  return {
    wochentagShort: d.toLocaleDateString('de-DE', { weekday: 'short' }).replace('.', ''),
    wochentag: d.toLocaleDateString('de-DE', { weekday: 'long' }),
    datum: d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit' }),
  }
}

// Kurzes Datum für Listen über mehrere Tage hinweg (z.B. Team-Suche) - Format "FR, 12.10.26"
// (Wochentag-Kurzform + zweistelliges Datum + zweistelliges Jahr), kompakter als formatTag
// (das volle vierstellige Jahr braucht's hier nicht, die Karte hat wenig Platz).
export function formatKurzDatum(zeit) {
  const d = new Date(zeit)
  if (Number.isNaN(d.getTime())) return ''
  const wochentag = d.toLocaleDateString('de-DE', { weekday: 'short' }).replace('.', '').toUpperCase()
  const pad = (n) => String(n).padStart(2, '0')
  const jahrKurz = String(d.getFullYear()).slice(-2)
  return `${wochentag}, ${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${jahrKurz}`
}

export function formatUhrzeit(zeit) {
  return new Date(zeit).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
}

// GEÄNDERT (komplett neues Konzept): Statt eines reinen Doppelpunkt-Countdowns, der - selbst
// mit "in "-Präfix - leicht mit einer normalen Uhrzeit verwechselt werden kann, sobald man nur
// flüchtig hinschaut, unterscheiden wir jetzt zwei Fälle:
//
// - Ziel ist HEUTE: echter Countdown mit Sekunden, den ganzen Tag über ("in HH:MM:SS") -
//   der "heute"-Kontext macht unmissverständlich klar, dass es sich um einen Countdown handelt.
// - Ziel ist an einem ANDEREN Tag: reines Wochentag+Uhrzeit-Format ("DI 21:00", "MI 15:30") -
//   das ist eindeutig ein TERMIN, keine Zahl, die man mit einem Countdown verwechseln könnte.
//   Die alte ">24h"-Tage-Stufe ("in 2T 10:03") fällt dadurch komplett weg - wird nicht mehr
//   gebraucht, da wir ab morgen ja gar nicht mehr "runterzählen".
const WOCHENTAGE_KURZ = ['SO', 'MO', 'DI', 'MI', 'DO', 'FR', 'SA']
 
export function formatCountdown(zielZeit, jetztMs) {
  const ziel = new Date(zielZeit)
  const jetzt = new Date(jetztMs)
  const diffMs = ziel.getTime() - jetztMs
  if (diffMs <= 0) return 'Gleich'
 
  const istHeute = ziel.getFullYear() === jetzt.getFullYear()
    && ziel.getMonth() === jetzt.getMonth()
    && ziel.getDate() === jetzt.getDate()
 
  const pad = (n) => String(n).padStart(2, '0')
 
  if (!istHeute) {
    return `${WOCHENTAGE_KURZ[ziel.getDay()]} ${pad(ziel.getHours())}:${pad(ziel.getMinutes())}`
  }
 
  // Heute: immer HH:MM:SS-Countdown, den ganzen Tag über (auch wenn's rechnerisch noch
  // Stunden hin sind - "heute" ist der Kontext, der's eindeutig macht)
  const gesamtSekunden = Math.floor(diffMs / 1000)
  const stunden = Math.floor(gesamtSekunden / 3600)
  const minuten = Math.floor((gesamtSekunden % 3600) / 60)
  const sekunden = gesamtSekunden % 60
  return `in ${pad(stunden)}:${pad(minuten)}:${pad(sekunden)}`
}
 

// Ermittelt den tatsächlich anzuzeigenden Status reaktiv, statt sich auf die einmalige
// Live-Erkennung aus mapMatch() zu verlassen: match.status (von REST/WebSocket) bleibt
// "geplant", bis entweder ein WS-Update reinkommt ODER die Seite neu geladen wird - dazwischen
// würde ein bereits angepfiffenes Spiel fälschlich weiter als "geplant"/Countdown angezeigt.
// jetztMs kommt von useClock (tickt jede Sekunde) -> diese Funktion in einem computed() nutzen,
// damit der Status automatisch kippt, sobald die Anstoßzeit erreicht wird - auch ganz ohne
// WebSocket-Update oder Neuladen der Seite.
export function ermittleAnzeigeStatus(match, jetztMs, countdownAbMinuten) {
  if (match.status === 'beendet' || match.status === 'live') return match.status
  const minutenBisAnpfiff = (new Date(match.zeit).getTime() - jetztMs) / 60000
  if (minutenBisAnpfiff <= 0) return 'live' // Anstoßzeit erreicht/überschritten
  if (minutenBisAnpfiff <= countdownAbMinuten) return 'bald'
  return 'geplant'
}

// Dev-Fallback: Falls ws-url noch der unveränderte Default-Platzhalter ist (kein explizit
// gesetzter Produktions-Wert), versuchen wir eine Registrierungs-ID aus dem localStorage zu
// holen und an den Pfad anzuhängen - der Vite-Dev-Proxy liest diese ID wieder aus dem Pfad
// heraus (siehe vite.config.js). Ist ws-url explizit gesetzt (Produktion), bleibt sie
// unangetastet - dieser Fallback greift NUR beim lokalen Testen.
export function ermittleWsUrl(wsUrlProp) {
  if (wsUrlProp !== '/ws-result-service') return wsUrlProp
  try {
    const id = localStorage.getItem('registrationId')
    return id ? `/ws-result-service/${id}` : wsUrlProp
  } catch {
    return wsUrlProp // localStorage evtl. nicht verfügbar (z.B. privates Fenster) - kein Absturz
  }
}

// hier robust in ein echtes Array aus Zahlen umwandeln, egal ob JSON-String ("[1,2,3]") oder
// einfache Kommaliste ("1,2,3") ankommt.
export function alsArray(wert) {
  if (Array.isArray(wert)) return wert
  if (typeof wert === 'string') {
    try {
      const geparst = JSON.parse(wert)
      if (Array.isArray(geparst)) return geparst
    } catch {
      // kein gültiges JSON -> als einfache Kommaliste interpretieren
    }
    return wert.split(',').map(s => Number(s.trim())).filter(n => !Number.isNaN(n))
  }
  return []
}

// "Mi., 21.10." (kurzer Wochentag, Tag, Monat)
export function formatDatumKurz(z) {
  return z
    ? new Date(z).toLocaleDateString('de-AT', { weekday: 'short', day: '2-digit', month: '2-digit' })
    : ''
}

// "20:45"
export function formatUhrzeitKurz(z) {
  return z
    ? new Date(z).toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' })
    : ''
}